import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Compressor from "compressorjs";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField as TextInputField,
  Typography,
  SelectChangeEvent,
  Button,
  InputAdornment,
  Tooltip,
  IconButton,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import {
  Formik,
  Form,
  ErrorMessage as ErrorMessageComponent,
  ErrorMessageProps,

  // useFormikContext,
} from "formik";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

import {
  useFetchTitles,
  useFetchCountries,
  useFetchStates,
  useFetchBanks,
  useFetchBankAccountName,
  useFetchBidPrice,
} from "../../../hooks/api/fetch";
import RegisterContext from "../../../context/RegisterContext";
import { IRegisterProps } from "../../../types/register";
import Dropzone from "react-dropzone";
import Image from "mui-image";
import { registrationConverter } from "../../../hooks/api/useConvertPayload";
import { registrationSchema } from "./validationSchema";
import MuiPhoneNumber from "mui-phone-number";
import { toast } from "react-toastify";
import InfoIcon from "@mui/icons-material/Info";
import title from "../../../data/title.json";
import { useDeleteRecord, useSaveForLaterCustomer } from "../../../hooks/api/post";
import { initialValues } from "../../../context/RegisterContext";
import {
  FormWrapper,
  IFormWrapper,
} from "../../../components/FormWrapper/FormWrapper";
import { encrypter } from "../../../hooks/helpers/encrypter";
interface IForm {
  setModalState: React.Dispatch<
    React.SetStateAction<{
      payment: boolean;
      accountDetails: boolean;
    }>
  >;
  setAuthState: React.Dispatch<React.SetStateAction<"register" | "confirm">>;
}

function RegisterForm(props: IForm) {
  const { setModalState } = props;
  const { state, dispatch } = useContext(
    RegisterContext
  ) as IRegisterContextProps;
  const [bankDetails, setBankDetails] = useState({
    bankCode: "",
    accountNumber: "",
    bankAccountType: 1,
  });

  // const acctName: any = useFetchBankAccountName();
  const fetchAccountName = useFetchBankAccountName();
const saveForLaterAPI= useSaveForLaterCustomer()
  // const formikContext = useFormikContext();
  const [filterStates, setFilterStates] = useState({
    country: "",
    state: "",
  });
  const [uploadedFiles, setUploadedFiles] = useState({
    passport: {
      name: "",
      url: "",
    },
    signature: {
      name: "",
      url: "",
    },
    utility: {
      name: "",
      url: "",
    },
    identity: {
      name: "",
      url: "",
    },
  });

  // const title = useFetchTitles();

  const countries = useFetchCountries();
  const states = useFetchStates(filterStates.country || "Nigeria");
  const nigeriaStates = useFetchStates("Nigeria");
  const banks = useFetchBanks();
  const prices = useFetchBidPrice();

  interface IUserInfo extends Partial<Applicant> {
    contactAddress: string;
    phoneNumber: string;
  }
  let userInfo: Partial<IUserInfo> = !!sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo") || "")
    : sessionStorage.getItem("userInfo");

  // userInfo = !!userInfo ? JSON.parse(`${userInfo}`) : userInfo;
  const [initialValues, setInitialValues] = useState<Applicant>({
    title: "",
    accountName: "",
    accountNumber: "",
    address: "",
    amount: "",
    bankName: "",
    bankCode:"",
    bvn: "",
    country: "",
    dateOfBirth: "",
    email: "",
    firstName: "",
    lastName: "",
    middleName: "",
    isPep: "",
    gender: "",
    lga: "",
    mobile: "",
    networth: "",
    nin: "",
    placeOfBirth: "",
    productType: "",
    referralCode: "",
    reinvest: "",
    nok_firstName: "",
    nok_middleName: "",
    nok_lastName: "",
    nok_email: "",
    nok_gender: "",
    nok_mobile: "",
    nok_relationship: "",
    nok_address: "",
    nok_state: "",
    relationshipStatus: "",
    state: "",
    survey: "",
    pepReason: "",
    passportName: "",
    passportUrl: "",
    signatureName: "",
    signatureUrl: "",
    idCardName: "",
    idCardUrl: "",
    utilityName: "",
    utilityUrl: "",
    paymentReference: null,
    paymentSource: 1,
    ldfPrice: Number(prices.data?.result?.[0]?.bidPrice),
  });
  useEffect(() => {
    if (userInfo?.email) {
      setInitialValues((prev) => ({
        ...prev,
        ...userInfo,
        passportUrl: "",
        passportName: "",
        signatureUrl: "",
        signatureName: "",
        idCardUrl: "",
        idCardName: "",
        utilityUrl: "",
        utilityName: "",
        // mobile: userInfo.phoneNumber || "",
        // nin: userInfo.nin?.toLocaleString().replaceAll("-", "") || "",
        // dateOfBirth: userInfo.dateOfBirth?.split("T")?.[0] || "",
        // address: userInfo.contactAddress || "",
        // // ...userInfo,
        // address: userInfo.contactAddress,
      }));
    }
  }, []);

  useEffect(() => {
    if (prices.data) {
      setInitialValues((prev) => ({
        ...prev,
        bidPrice: [
          {
            product: "lmmf",
            quantity: 1000,
            price: Number(prices.data?.result?.[2]?.bidPrice),
          },
          {
            product: "ldf",
            quantity: 25000,
            price: Number(prices.data?.result?.[0]?.bidPrice),
          },
          {
            product: "lef",
            quantity: 10000,
            price: Number(prices.data?.result?.[1]?.bidPrice),
          },
          {
            product: "luf",
            quantity: 1000,
            price: Number(prices.data?.result?.[3]?.bidPrice),
          },
        ],
        ldfPrice: Number(prices.data?.result?.[0]?.bidPrice),
        lefPrice: Number(prices.data?.result?.[1]?.bidPrice),
        lmmfPrice: Number(prices.data?.result?.[2]?.bidPrice),
        lufPrice: Number(prices.data?.result?.[3]?.bidPrice),
      }));
    }
  }, [prices.data]);

  const handleFetchAcctName = (
    setFieldValue: any,
    bankShortCode: string,
    accountNumber: string
  ) => {
    if (accountNumber.length >= 10) {
      const bankCode = banks?.data?.result?.find(
        (data: any) => data?.bankName === bankShortCode
      )?.newBankCode;
      console.log({
        banks,
        bankCode,
        // ttt: banks?.data?.result?.forEach(
        //   (data: any) => data?.bankName === bankShortCode
        // ),
      });
      let bankAccountType = bankCode === "000003" ? 1 : 2;
      setBankDetails((prev) => ({
        ...prev,
        bankCode,
        bankAccountType,
        accountNumber,
      }));

      setFieldValue("accountName", "Fetching Account Name");
      fetchAccountName.mutate(
        {
          bankCode,
          bankAccountType,
          accountNumber,
        },
        {
          onSuccess: (res: any) => {
            // setFieldValue("accountName", acctName?.data?.result?.accountName);
            setFieldValue("accountName", res?.result?.accountName);
          },
          onError: (res: any) => {
            setFieldValue("accountName", "Account doesn't exist");
          },
        }
      );
      //
    } else {
      setFieldValue("accountName", "");
    }
  };

  const initialTouchedValues = {
    title: true,
    accountName: true,
    accountNumber: true,
    address: true,
    amount: true,
    bankName: true,
    bvn: true,
    country: true,
    dateOfBirth: true,
    email: true,
    firstName: true,
    lastName: true,
    middleName: true,
    isPep: true,
    gender: true,
    lga: true,
    mobile: true,
    networth: true,
    nin: true,
    placeOfBirth: true,
    productType: true,
    referralCode: true,
    reinvest: true,
    nok_firstName: true,
    nok_middleName: true,
    nok_lastName: true,
    nok_email: true,
    nok_gender: true,
    nok_mobile: true,
    nok_relationship: true,
    nok_address: true,
    nok_state: true,
    relationshipStatus: true,
    state: true,
    survey: true,
    pepReason: true,
    passportName: true,
    passportUrl: true,
    signatureName: true,
    signatureUrl: true,
    idCardName: true,
    idCardUrl: true,
    utilityName: true,
    utilityUrl: true,
    paymentReference: true,
    paymentSource: true,
    ldfPrice: true,
  };
  return (
    <Box
      sx={{
        "& .MuiTextField-root": {},
      }}
    >
      <Formik
        initialValues={initialValues}
        initialTouched={initialTouchedValues}
        enableReinitialize={true}
        validationSchema={registrationSchema}
        onSubmit={(values: Applicant, { setSubmitting }) => {
          sessionStorage.setItem("userInfo", JSON.stringify(values));
          // values.bvn= encrypter(values.bvn)
          // values.nin= encrypter(values.nin)
          // values.mobile= encrypter(values.mobile)
          // values.AmountInText= encrypter(values.amount)
          // values.accountNumber= encrypter(values.accountNumber)
          // values.bankName= encrypter(values.bankName)
          // values.bankCode=encrypter(values.bankCode)
          // values.accountName= encrypter(values.accountName)
          // values.email= encrypter(values.email)
          // values.address= encrypter(values.address)
          // values.nok_email= encrypter(values.nok_email)
          // values.nok_mobile= encrypter(values.nok_mobile)
          // values.nok_address= encrypter(values.nok_address)
         
          sessionStorage.setItem("email", encrypter(values.email));
        
          setSubmitting(true);
          let valuesCopy = { ...values } as any;
          valuesCopy.isPep = values.isPep === "1" ? true : false;
          valuesCopy.gender = values.gender === "1" ? 1 : 2;
          const val2 = registrationConverter({
            ...values,
            bvn: encrypter(values.bvn),
          nin: encrypter(values.nin),
          mobile: encrypter(values.mobile),
          AmountInText: encrypter(values.amount),
          accountNumber: encrypter(values.accountNumber),
          bankName: encrypter(values.bankName),
          bankCode:encrypter(values.bankCode),
          accountName: encrypter(values.accountName),
          email: encrypter(values.email),
          address: encrypter(values.address),
          nok_email: encrypter(values.nok_email),
          nok_mobile: encrypter(values.nok_mobile),
          nok_address: encrypter(values.nok_address),
         
          });
          dispatch(
            (prev: IRegisterProps) =>
              prev && {
                ...prev,

                // accountDetails: true,
                payment: true,
                values: val2,
              }
          );
          setSubmitting(false);
        }}
      >
        {({
          isSubmitting,
          values,
          setFieldValue,
          errors,
          isValid,
          touched,
          handleChange,
          handleBlur,
          validateForm,
          handleSubmit,

          ...rest
        }) => {
          return (
            <Form>
              <FormWrapper title="Personal Details">
                {/* Personal det */}
                <Grid
                  container
                  // xs={12}
                  gap={2}
                  justifyContent={"space-between"}
                >
                  <Grid item xs={12} md={2.8}>
                    <AutoCompleteField
                      name="title"
                      required={true}
                      value={values.title}
                      label="Title"
                      errors={errors}
                      onChange={(event, newValue) => {
                        setFieldValue("title", newValue);
                        // validateForm();
                        // handleSubmit();
                      }}
                      options={title?.map((title: any) => {
                        title.value = title.titleCode;
                        title.label = title.titleDescription;
                        return title;
                      })}
                    />
                    <ErrorMessage name="title" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextInputField
                      // helperText={errors["firstName"] || null}
                      required
                      fullWidth
                      name={"firstName"}
                      value={values.firstName}
                      label="First Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      // handleChange={ }
                    />

                    <ErrorMessage
                      component={"div"}
                      className="error"
                      name="firstName"
                    />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      value={values.middleName}
                      fullWidth
                      name="middleName"
                      label="Middle Name"
                    />
                    <ErrorMessage name="middleName" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      // errors={errors}
                      required
                      setFieldValue={setFieldValue}
                      value={values.lastName}
                      fullWidth
                      name="lastName"
                      label="Last Name"
                    />
                    <ErrorMessage name="lastName" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <SelectField
                      name="gender"
                      required
                      label="Gender"
                      value={values.gender}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("gender", e.target.value)
                      }
                      options={[
                        { label: "Male", value: 1 },
                        { label: "Female", value: 2 },
                      ]}
                    />{" "}
                    <ErrorMessage name="gender" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    {/* <TextField
                      required
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="mobile"
                      value={values.mobile}
                      label="Phone Number"
                    /> */}
                    <MuiPhoneNumber
                      fullWidth
                      defaultCountry={"ng"}
                      onChange={(e) => {
                        setFieldValue(
                          "mobile",
                          e.toString().replaceAll(/[\(\)-\s]/g, "")
                        );
                      }}
                      required
                      placeholder="Phone Number"
                      variant="outlined"
                      value={values.mobile}
                      sx={{
                        "& svg": {
                          height: "1em",
                        },
                      }}
                    />

                    <ErrorMessage name="mobile" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      value={values.email}
                      required
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="email"
                      label="Email"
                      handleChange={(e:any)=>{
setFieldValue("email", e.currentTarget.value)
}}
onBlur={
  (e:any)=>{
  saveForLaterAPI.mutate({emailAddress:encrypter(values.email), firstName:values.firstName, lastName:values.lastName, phoneNumber:encrypter(values.mobile)})

}
                      }
                    />
                    <ErrorMessage name="email" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      required
                      InputLabelProps={{ shrink: true }}
                      setFieldValue={setFieldValue}
                      type="date"
                      fullWidth
                      name="dateOfBirth"
                      // inputFormat="dd/MM/yyyy"
                      // defaultValue={"2020-01-01"}
                      value={values.dateOfBirth}
                      label="Date of birth"
                    />
                    <ErrorMessage name="dateOfBirth" />
                  </Grid>
                  <Grid item xs={12} md={3.8}>
                    <SelectField
                      required
                      name="relationshipStatus"
                      label="Relationship Status"
                      value={values.relationshipStatus}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("relationshipStatus", e.target.value)
                      }
                      options={[
                        { label: "Single", value: 1 },
                        { label: "Married", value: 2 },
                        { label: "Widow", value: 3 },
                        { label: "Widower", value: 4 },
                      ]}
                    />{" "}
                    <ErrorMessage name="relationshipStatus" />
                  </Grid>
                  <Grid item xs={12} md={3.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      required
                      fullWidth
                      value={values.bvn}
                      name="bvn"
                      label="BVN"
                      tooltip="
                      Can't remember? Dial *565*0# on your registered phone number to get your BVN"
                    />
                    <ErrorMessage name="bvn" />
                  </Grid>
                  <Grid item xs={12} md={3.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      required
                      fullWidth
                      value={values.nin}
                      name="nin"
                      label="NIN"
                      tooltip="Can't remember? Dial *346# on your registered phone number to get your NIN"
                    />
                    <ErrorMessage name="nin" />
                  </Grid>

                  <Grid item xs={12} md={2.8}>
                    <AutoCompleteField
                      name="country"
                      label="Nationality"
                      required={true}
                      value={values.country}
                      onChange={(e, newValue) => {
                        setFieldValue("country", newValue);
                        // console.log({
                        //   e: e.target.value,
                        //   b: [...countries.data].find(
                        //     (data: any) => data.value === e.target.value
                        //   ),
                        // });

                        setFilterStates((prev) => ({
                          ...prev,
                          country: countries.data.find(
                            (data: any) => data.value === newValue
                          )?.label,
                        }));
                      }}
                      options={
                        countries.data
                          ? [
                              ...countries.data?.map((title: any) => {
                                title.label = title.countryName;
                                title.value = title.countryIsoCode;
                                return title;
                              }),
                            ]
                          : [
                              {
                                label: "",
                                value: "",
                              },
                            ]
                      }
                    />
                    <ErrorMessage name="country" />
                  </Grid>
                  {filterStates.country && (
                    <Grid item xs={12} md={2.8}>
                      <SelectField
                        name="state"
                        label="State of Residence"
                        value={values.state}
                        onChange={(e: SelectChangeEvent) =>
                          setFieldValue("state", e.target.value)
                        }
                        options={
                          states?.data
                            ? states.data?.[0]?.States?.map((title: any) => {
                                title.label = title.StateName;
                                title.value = title.StateCode;
                                return title;
                              })
                            : states?.isLoading
                            ? [
                                {
                                  label: "Fetching States",
                                  value: " ",
                                },
                              ]
                            : []
                        }
                      />

                      <ErrorMessage name="state" />
                    </Grid>
                  )}
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="lga"
                      label="L.G.A"
                      value={values.lga}
                    />
                    <ErrorMessage name="lga" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      value={values.placeOfBirth}
                      name="placeOfBirth"
                      label="Place of Birth"
                    />
                    <ErrorMessage name="placeOfBirth" />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      value={values.address}
                      required
                      multiline
                      rows={5}
                      fullWidth
                      name="address"
                      label="Contact Address"
                    />
                    <ErrorMessage name="address" />
                  </Grid>
                </Grid>
              </FormWrapper>

              {/* Bank Details */}
              <FormWrapper
                title="Personal Bank Details"
                bgcolor="secondary.main"
              >
                <Grid container gap={2} justifyContent={"space-between"}>
                  <Grid item xs={12} md={5.8}>
                  
                    <AutoCompleteField
                      name="bankName"
                      required
                      label="Bank Name"
                      value={values.bankName}
                      onChange={(e: SelectChangeEvent, newValue) => {
                        setFieldValue("bankName", newValue);
                        const bankCode= banks?.data?.result?.find(
                          (data: any) => data?.bankName === newValue
                        )?.newBankCode
                        setFieldValue("bankCode", bankCode);
                        // handleFetchAcctName(
                        //   setFieldValue,
                        //   newValue,
                        //   values.accountNumber as string
                        //   // values.accountNumber as string
                        // );
                      }}
                      options={banks?.data?.result || []}
                    />{" "}
                    <ErrorMessage name="bankName" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <TextField
                      errors={errors}
                      // setFieldValue={setFieldValue}

                      handleChange={(e: any) => {
                        setFieldValue("accountNumber", e.target.value);
                        // handleFetchAcctName(
                        //   setFieldValue,
                        //   values.bankName,
                        //   e.target.value
                        //   // values.accountNumber as string
                        // );
                      }}
                      required
                      fullWidth
                      value={values.accountNumber}
                      name="accountNumber"
                      label="Account Number"
                    />
                    <ErrorMessage name="accountNumber" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <TextField
                      errors={errors}
                      // disabled
                      setFieldValue={setFieldValue}
                      required={true}
                      fullWidth
                      value={values.accountName}
                      name="accountName"
                      placeholder="Account Name"
                      label="Account Name"
                    />
                    <ErrorMessage name="accountName" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <SelectField
                      required
                      name="networth"
                      label="What is your net worth?"
                      value={values.networth || ""}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("networth", e.target.value)
                      }
                      options={[
                        { label: "N1,000 - N20M ", value: "1" },
                        { label: "N20M - N500M ", value: "2" },
                        { label: "N500M - N3.75B", value: "3" },
                        { label: "Above N3.75B ", value: "4" },
                      ]}
                    />{" "}
                    <ErrorMessage name="networth" />
                  </Grid>
                </Grid>
              </FormWrapper>

              {/* Next of Kin */}
              <FormWrapper title="Next of kin Details">
                {/* Personal det */}
                <Grid
                  container
                  xs={12}
                  gap={2}
                  justifyContent={"space-between"}
                >
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      required={true}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="nok_firstName"
                      label="First Name"
                      value={values.nok_firstName}
                    />
                    <ErrorMessage name="nok_firstName" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="nok_middleName"
                      label="Middle Name"
                      value={values.nok_middleName}
                    />
                    <ErrorMessage name="nok_middleName" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      required
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="nok_lastName"
                      label="Last Name"
                      value={values.nok_lastName}
                    />
                    <ErrorMessage name="nok_lastName" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <SelectField
                      name="gender"
                      required
                      label="Gender"
                      value={values.nok_gender}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("nok_gender", e.target.value)
                      }
                      options={[
                        { label: "Male", value: "1" },
                        { label: "Female", value: "2" },
                      ]}
                    />{" "}
                    <ErrorMessage name="nok_gender" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <AutoCompleteField
                      name="nok_state"
                      label="State"
                      required
                      value={values.nok_state}
                      onChange={(e, newValue) =>
                        setFieldValue("nok_state", newValue)
                      }
                      options={
                        nigeriaStates.data
                          ? nigeriaStates.data?.[0]?.States?.map(
                              (title: any) => {
                                title.label = title.StateName;
                                title.value = title.StateCode;
                                return title;
                              }
                            )
                          : [
                              {
                                label: "",
                                value: "",
                              },
                            ]
                      }
                    />{" "}
                    <ErrorMessage name="nok_state" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <SelectField
                      name="nok_relationship"
                      required
                      label="Relationship"
                      value={values.nok_relationship}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("nok_relationship", e.target.value)
                      }
                      options={[
                        { label: "Brother", value: 1 },
                        { label: "BrotherInLaw", value: 2 },
                        { label: "Daughter", value: 3 },
                        { label: "Daughter", value: 4 },
                        { label: "Father", value: 5 },
                        { label: "FatherInLaw", value: 6 },
                        { label: "Husband", value: 7 },
                        { label: "Mother", value: 8 },
                        { label: "MotherInLaw", value: 9 },
                        { label: "Sister", value: 10 },
                        { label: "SisterInLaw", value: 11 },
                        { label: "Son", value: 12 },
                        { label: "Wife", value: 13 },
                      ]}
                    />{" "}
                    <ErrorMessage name="nok_relationship" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    {/* <TextField
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="nok_mobile"
                      label="Phone Number"
                    /> */}
                    <MuiPhoneNumber
                      fullWidth
                      defaultCountry={"ng"}
                      onChange={(e) => {
                        setFieldValue(
                          "nok_mobile",
                          e.toString().replaceAll(/[\(\)-\s]/g, "")
                        );
                      }}
                      value={values.nok_mobile}
                      required
                      placeholder="Phone Number"
                      variant="outlined"
                      sx={{
                        "& svg": {
                          height: "1em",
                        },
                      }}
                    />
                    <ErrorMessage name="nok_mobile" />
                  </Grid>
                  <Grid item xs={12} md={2.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="nok_email"
                      label="Email"
                      type="email"
                      value={values.nok_email}
                    />
                    <ErrorMessage name="nok_email" />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      required
                      multiline
                      rows={5}
                      fullWidth
                      name="nok_address"
                      label="Contact Address"
                      value={values.nok_address}
                    />
                    <ErrorMessage name="nok_address" />
                  </Grid>
                </Grid>
              </FormWrapper>

              {/* <Typography variant="h6" mt={3} mb={2} color="primary.main">
                Product Subscription
              </Typography> */}
              {/* Products */}
              <FormWrapper title="Product Subscription">
                <Grid
                  container
                  gap={2}
                  justifyContent={"space-between"}
                  xs={12}
                >
                  <Grid item xs={12} md={5.8}>
                    <SelectField
                      name="productType"
                      required
                      label="Select Fund Type"
                      value={values.productType}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("productType", e.target.value)
                      }
                      options={[
                        { label: "Legacy Money Market Fund", value: "1" },
                        { label: "Legacy Debt Fund", value: "2" },
                        { label: "Legacy Equity Fund", value: "3" },
                        { label: "Legacy USD Bond Fund", value: "4" },
                      ]}
                    />{" "}
                    <ErrorMessage name="productType" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <TextField
                      errors={errors}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {values.productType === "4" ? "$" : "N"}
                          </InputAdornment>
                        ),
                      }}
                      setFieldValue={setFieldValue}
                      required
                      fullWidth
                      name="amount"
                      label="Amount"
                      value={values.amount}
                      tooltip={`The minimum amount to be invested is ${
                        Number(
                          initialValues?.bidPrice?.[
                            Number(values.productType) - 1 < 0
                              ? 0
                              : Number(values.productType) - 1
                          ]?.quantity
                        ) *
                        Number(
                          initialValues?.bidPrice?.[
                            Number(values.productType) - 1 < 0
                              ? 0
                              : Number(values.productType) - 1
                          ]?.price
                        )
                      }`}
                    />
                    <ErrorMessage name="amount" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <SelectField
                      name="reinvest"
                      required
                      label="Do you want your interest re-invested?"
                      value={values.reinvest}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("reinvest", e.target.value)
                      }
                      options={[
                        { label: "Yes", value: "1" },
                        {
                          label: "No",
                          value: "0",
                        },
                      ]}
                    />{" "}
                    <ErrorMessage name="reinvest" />
                  </Grid>
                </Grid>
              </FormWrapper>
              {/* <Typography variant="h6" mt={3} mb={2} color="primary.main">
                Survey
              </Typography> */}
              <FormWrapper title="Survey" bgcolor="secondary.main">
                <Grid
                  container
                  gap={2}
                  justifyContent={"space-between"}
                  xs={12}
                >
                  <Grid item xs={12} md={5.8}>
                    <SelectField
                      required
                      name="survey"
                      label="How did you hear about us?"
                      value={values.survey}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("survey", e.target.value)
                      }
                      options={[
                        { label: "Twitter", value: "Twitter" },
                        {
                          label: "Facebook",
                          value: "Facebook",
                        },
                        { label: "Instagram", value: "Instagram" },
                        { label: "Linkedin", value: "Linkedin" },
                        { label: "Email", value: "Email" },
                        { label: "Whatsapp", value: "Whatsapp" },
                        { label: "Google Search", value: "Google Search" },
                        {
                          label: "Through A Friend",
                          value: "Through A Friend",
                        },
                        { label: "Others", value: "Others" },
                      ]}
                    />{" "}
                    <ErrorMessage name="survey" />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <TextField
                      errors={errors}
                      setFieldValue={setFieldValue}
                      fullWidth
                      name="referralCode"
                      label="Referral Code"
                    />
                    <ErrorMessage name="accountNumber" />
                  </Grid>
                </Grid>
              </FormWrapper>
              <FormWrapper title=" Additional Details" bgcolor="primary.main">
                {/* <Typography variant="h6" mt={3} mb={2} color="primary.main">
                  Additional Details
                </Typography> */}
                <Grid
                  container
                  gap={2}
                  justifyContent={"space-between"}
                  xs={12}
                >
                  <Grid item xs={12} md={5.8}>
                    <Box mt={{ md: -3 }}>
                      <Tooltip
                        // title={props.tooltip}
                        title="PEPs include Individuals who are or have been entrusted with prominent public functions in any country or prominent function by an international organization. This includes their family members and people and entities associated with them. e.g Politicians; senior government, judicial or military officials; members of royal family; directors, deputy directors and members of the board in an international organization."
                        enterTouchDelay={0}
                      >
                        <InfoIcon
                          color="primary"
                          sx={{ fontSize: "18px", fontStyle: "italic" }}
                        />
                      </Tooltip>
                    </Box>

                    <SelectField
                      name="isPep"
                      required
                      label="Are you a Politically Exposed Person (PEP)?"
                      value={values.isPep}
                      onChange={(e: SelectChangeEvent) =>
                        setFieldValue("isPep", e.target.value)
                      }
                      options={[
                        { label: "Yes", value: "1" },
                        { label: "No", value: "0" },
                      ]}
                    />
                    <ErrorMessage name="isPep" />
                  </Grid>
                  {values.isPep === "1" && (
                    <Grid item xs={12} md={5.8}>
                      <TextField
                        errors={errors}
                        setFieldValue={setFieldValue}
                        required
                        fullWidth
                        name="pepReason"
                        label="If yes, please give details"
                      />
                      <ErrorMessage name="pepReason" />
                    </Grid>
                  )}
                </Grid>
              </FormWrapper>
              {/* <Typography variant="h6" mt={3} mb={2} color="primary.main">
                KYC - Documentation
              </Typography> */}
              <FormWrapper title="KYC - Documentation" bgcolor="secondary.main">
                <Grid
                  container
                  gap={2}
                  justifyContent={"space-between"}
                  xs={12}
                >
                  <Grid item xs={12} md={5.8}>
                    <UploadDocument
                      field="passportName"
                      fieldUrl="passportUrl"
                      label="Upload a Passport: "
                      placeholder=" Select a file or drop one here"
                      setFieldValue={setFieldValue}
                      setUploadedFiles={setUploadedFiles}
                      uploadedFiles={uploadedFiles}
                    />
                  </Grid>
                  <Grid item xs={12} md={5.8}>
                    <UploadDocument
                      field="signatureName"
                      fieldUrl="signatureUrl"
                      label="Upload a Signature: "
                      placeholder=" Select a file or drop one here"
                      setFieldValue={setFieldValue}
                      setUploadedFiles={setUploadedFiles}
                      uploadedFiles={uploadedFiles}
                    />
                  </Grid>

                  {(values.productType !== "1" ||
                    Number(values.amount) > 20000) && (
                    <Grid item xs={12} md={5.8}>
                      <UploadDocument
                        field="utilityName"
                        fieldUrl="utilityUrl"
                        label="Utility Picture : "
                        placeholder=" Upload Your Utility Picture"
                        setFieldValue={setFieldValue}
                        setUploadedFiles={setUploadedFiles}
                        uploadedFiles={uploadedFiles}
                      />
                    </Grid>
                  )}
                  {(values.productType !== "1" ||
                    Number(values.amount) > 20000) && (
                    <Grid item xs={12} md={5.8}>
                      <UploadDocument
                        field="idCardName"
                        fieldUrl="idCardUrl"
                        label="Means of Identification: "
                        placeholder=" Select a file or drop one here"
                        setFieldValue={setFieldValue}
                        setUploadedFiles={setUploadedFiles}
                        uploadedFiles={uploadedFiles}
                      />
                    </Grid>
                  )}
                </Grid>
              </FormWrapper>

              {/* Submit Button */}
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  // color="secondary"
                  disabled={!isValid || isSubmitting}
                >
                  Submit
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}

interface ISelectFieldProps {
  name: string;
  value?: string;
  label: string;
  errors?: any;
  onChange: (e: SelectChangeEvent) => void;
  options: { label: string; value: string | number }[];
  required?: boolean;
}
function SelectField(props: ISelectFieldProps) {
  //
  return (
    <FormControl fullWidth required={props?.required}>
      <InputLabel id="demo-simple-select-label">{props?.label}</InputLabel>

      <Select
        required={props.required}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={props?.value || ""}
        label={props?.label}
        onChange={props.onChange}
      >
        <MenuItem value=" " disabled>
          Select
        </MenuItem>
        {props?.options?.map((item) => (
          <MenuItem key={uuidv4()} value={item?.value || ""}>
            {item?.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText
        sx={{
          "& .MuiFormHelperText-root": {
            color: "blue",
            fontSize: 12,
          },
        }}
      >
        {props.errors?.[props.name] || null}
      </FormHelperText>
    </FormControl>
  );
}

interface IAutoComplete extends Omit<ISelectFieldProps, "onChange"> {
  onChange: (event: any, newValue: any) => void;
}
function AutoCompleteField(props: IAutoComplete) {
  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={props.options}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      // sx={{ width: 300 }}

      onChange={(event, newValue) => {
        props.onChange(event, newValue?.value);
        //
      }}
      renderInput={(params) => (
        <TextInputField
          required={props.required}
          {...params}
          label={props.label}
        />
      )}
    />
  );
}
// interface ITitleProps {
//   title: string;
//   bgcolor: string;
// }
// function Title(props: ITitleProps) {
//   return (
//     <Box
//       sx={{
//         p: 1,
//         pl: 2,
//         // mb: 1,
//         // bgcolor: props.bgcolor || "primary.main",
//         bgcolor: "primary.main",
//         borderTopLeftRadius: 20,
//         borderTopRightRadius: 20,
//       }}
//     >
//       <Typography variant="h6" color="white" fontWeight={700}>
//         {props.title}
//       </Typography>
//     </Box>
//   );
// }

// interface IFormWrapper extends IWrapper {
//   title: string;
//   bgcolor?: string;
// }
// export function FormWrapper(props: IFormWrapper) {
//   return (
//     <Box
//       sx={{
//         border: "1px solid #fff6f6",
//         boxShadow: "3px 3px 15px #fff6f6, -3px -3px 15px #fff6f6",
//         borderRadius: 5,
//         mb: 2,
//         // p: 1,
//       }}
//     >
//       <Title title={props.title} bgcolor={props.bgcolor || "primary.main"} />
//       <Box p={3}>{props.children}</Box>
//     </Box>
//   );
// }
interface IText {
  setFieldValue?: any;
  handleChange?: any;
  handleBlur?:any;
  // (field: string, value: any, shouldValidate?: boolean | undefined) => Promise<void | FormikErrors<Applicant>>;
  name: string;
  tooltip?: string;
  errors?: any;

  [propName: string]: any;
}
function TextField(props: IText) {
  return (
    <Box>
      {!!props.tooltip && (
        <Box mt={{ md: -3 }}>
          <Tooltip title={props.tooltip} enterTouchDelay={0}>
            <InfoIcon
              color="primary"
              sx={{ fontSize: "18px", fontStyle: "italic" }}
            />
          </Tooltip>
        </Box>
      )}
      <TextInputField
        {...props}
        name={props.name}
        onChange={(e) =>
          props?.handleChange
            ? props.handleChange(e)
            : props?.setFieldValue(props.name, e.target.value)
        }
       
        // helperText={props.errors?.[props.name] || null}
        sx={{
          "& .MuiFormHelperText-root": {
            color: "blue",
          },
        }}
      />
    </Box>
  );
}

interface IUploadDocument extends Partial<IFormWrapper> {
  field: string;
  fieldUrl: string;
  setFieldValue: any;
  setUploadedFiles: any;
  uploadedFiles: any;
  label: string;
  placeholder: string;
  errors?: any;
}
function UploadDocument(props: IUploadDocument) {
  const {
    field,
    fieldUrl,
    setFieldValue,
    setUploadedFiles,
    uploadedFiles,
    label,
    placeholder,
    errors,
  } = props;

  return (
    <Box>
      <Dropzone
        onDrop={(acceptedFiles, reject) => {
          let file = acceptedFiles[0];
          //
          //
          new Compressor(file, {
            quality: file.size > 6000000 ? 0.4 : 0.6,
            success(file: File) {
              //

              if (
                file.size < 1000000 &&
                /image\/(png|jpg|jpeg)/gm.test(file.type)
              ) {
                let url = URL.createObjectURL(file);
                const reader = new FileReader();

                setFieldValue(field, file.name);
                reader.onload = (event: any) => {
                  const data = event.target.result.split(",").pop(); // Get base64 data

                  // setFieldValue(field, file?.name);
                  setFieldValue(
                    fieldUrl,
                    data
                    // `data:image/${file.type};base64,${data}`
                  );
                  setUploadedFiles((prev: any) => ({
                    ...prev,
                    [field]: {
                      name: file.name,
                      url: `data:image/${file.type};base64,${data}`,
                    },
                  }));
                  // setBase64Data(data);
                };
                reader.readAsDataURL(file);

                //
              } else {
                toast.dismiss();
                toast.warn(
                  "File in incorrect format or file is larger than 1mb"
                );
              }
            },
          });
        }}
        onDragOver={(event) => {
          event.preventDefault();
        }}
      >
        {({ getInputProps, getRootProps }) => (
          <Box {...getRootProps()}>
            {" "}
            <input {...getInputProps()} />
            <Typography variant="body2" fontSize={13} mb={0.1}>
              {label}
            </Typography>
            <Box
              minHeight={50}
              p={2}
              sx={{
                borderRadius: 1,
                border: "1px solid #f0f0f0",
                cursor: "pointer",
              }}
            >
              <Box
                sx={{ display: "flex" }}
                alignItems="center"
                justifyContent="space-between"
              >
                <Box>
                  <Typography variant="h5" fontWeight="700">
                    {" "}
                    {uploadedFiles?.[field]?.name || placeholder}
                  </Typography>
                  <Typography variant="body2" fontWeight="400" mt={1}>
                    {" "}
                    Select a file or drop one here
                  </Typography>
                </Box>
                <Box sx={{ maxWidth: "100px" }}>
                  {uploadedFiles?.[field]?.url ? (
                    <Image src={uploadedFiles?.[field]?.url} />
                  ) : (
                    <DriveFolderUploadIcon color="secondary" fontSize="large" />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Dropzone>
    </Box>
  );
}

function ErrorMessage(props: ErrorMessageProps) {
  return (
    <ErrorMessageComponent
      {...props}
      component={"div"}
      className="error"
      name={props?.name}
    />
  );
}
export default RegisterForm;
